module.exports = __webpack_public_path__ + "static/02-2a6b1364d60e4ecc57abcd036e130617.jpg";